<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import { cubicOut } from 'svelte/easing';
  import { fade } from 'svelte/transition';

  import RoastLogLogo from '$lib/images/logo-white.svelte';

  import { sidebarHidden } from '$lib/Stores';

  const dispatch = createEventDispatcher();

  function slidefade(
    node: HTMLElement,
    params: { delay?: number; duration?: number; easing?: any } = {}
  ) {
    // I don't think there are any existing transforms, so can just ignore this.
    // const existingTransform = getComputedStyle(node).transform.replace('none', '');
    // `transform-origin: top left;` + `transform:  scaleX(${t});` + `opacity: ${t};`

    return {
      delay: params.delay || 0,
      duration: params.duration || 300,
      easing: params.easing || cubicOut,
      css: (t: any, u: any) => {
        return (
          `transform-origin: top left;` + `transform: translate(-${u * 100}%);` + `opacity: ${t};`
        );
      }
    };
  }
</script>

<div class="relative z-50" class:hidden={$sidebarHidden} role="dialog" aria-modal="true">
  <!--
      Off-canvas menu backdrop, show/hide based on off-canvas menu state.
      Entering: "transition-opacity ease-linear duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "transition-opacity ease-linear duration-300"
        From: "opacity-100"
        To: "opacity-0"
      transition:slide={{ axis: 'x' }}
    <div class="fixed inset-0 bg-gray-900/80" transition:slide={{ axis: 'x' }}></div>
    -->
  {#if !$sidebarHidden}
    <div class="fixed inset-0 bg-gray-900/80" transition:fade></div>

    <div class="fixed inset-0 flex">
      <!--
        Off-canvas menu, show/hide based on off-canvas menu state.

        Entering: "transition ease-in-out duration-300 transform"
          From: "-translate-x-full"
          To: "translate-x-0"
        Leaving: "transition ease-in-out duration-300 transform"
          From: "translate-x-0"
          To: "-translate-x-full"
      -->

      <div class="relative mr-16 flex w-full max-w-xs flex-1" transition:slidefade>
        <!--
          Close button, show/hide based on off-canvas menu state.

          Entering: "ease-in-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in-out duration-300"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="absolute left-full top-0 flex w-16 justify-center pt-5" transition:fade>
          <button type="button" class="-m-2.5 p-2.5" onclick={() => dispatch('closemenu')}>
            <span class="sr-only">Close sidebar</span>
            <svg
              class="h-6 w-6 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div
          class="flex grow flex-col gap-y-5 overflow-y-auto bg-gray-900 px-6 pb-4 ring-1 ring-white/10"
        >
          <div class="flex h-16 shrink-0 items-center">
            <div class="h-8 w-8">
              <RoastLogLogo />
            </div>
          </div>

          <nav class="flex flex-1 flex-col">
            <div class="text-white">small sidebar</div>
          </nav>
        </div>
      </div>
    </div>
  {/if}
</div>
